import { Box, Stack, useMediaQuery, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import SideNavigationComponent from "../../components/widgets/sideNavigationComponent";
import TabsComponent from "../../components/widgets/tabsComponent";
import DigitalStudioUIUX from "./digitalStudioUIUX";
import DigitalStudioArtworks from "./digitalStudioArtworks";
import DigitalStudioAnimations from "./digitalStudioAnimations";
import DigitalStudioCinematic from "./digitalStudioCinematic";
import { useCallback, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

const DigitalStudioTabView = () => {
    const theme = useTheme();
    const {t} = useTranslation();

    const digitalStudioList = [
        {label: t('services.home.list.ux.label'), children: <DigitalStudioUIUX />},
        {label: t('services.home.list.artworks.label'), children: <DigitalStudioArtworks />},
        {label: t('services.home.list.animations.label'), children: <DigitalStudioAnimations />},
        {label: t('services.home.list.video.label'), children: <DigitalStudioCinematic />}
    ];

    const isLargeDevice = useMediaQuery(theme.breakpoints.up("lg"));

    const [selectedTabIndex, setSelectedTabIndex] = useState(0);

    const { hash } = useLocation();

    useEffect(() => {
        if(hash){
            console.log(hash);

            switch(hash){
                case "#uiux":
                    setSelectedTabIndex(0);
                    break;
                case "#artworks":
                    setSelectedTabIndex(1);
                    break;
                case "#animations":
                    setSelectedTabIndex(2);
                    break;
                case "#cinematic":
                    setSelectedTabIndex(3);
                    break;
                default:
                    document.location.hash = 'uiux';
                    setSelectedTabIndex(0);
                    break;
            }
        }
        else{
            document.location.hash = 'uiux';
            setSelectedTabIndex(0);
        }
    }, [hash]);

    const changeTabValues = useCallback((newValue) => {
        switch(newValue){
            case 0:
                document.location.hash = 'uiux';
                break;
            case 1:
                document.location.hash = 'artworks';
                break;
            case 2:
                document.location.hash = 'animations';
                break;
            case 3:
                document.location.hash = 'cinematic';
                break;
            default:
                document.location.hash = 'uiux';
                break;
        }
    }, []);

    return (
        <>
            <Box
                className="sectionSpacing"
                sx={{
                    width: '100%'
                }}
            >
                {
                    isLargeDevice
                    ?
                    <SideNavigationComponent 
                        list={digitalStudioList}
                        manualIndex={selectedTabIndex}
                        customChangeFunction={changeTabValues}
                        tabsSx={{
                            width: 225
                        }}
                    />
                    :
                    <TabsComponent 
                        list={digitalStudioList}
                        manualIndex={selectedTabIndex}
                        customChangeFunction={changeTabValues}
                    />
                }
            </Box>
        </>
    );
}

export default DigitalStudioTabView;